import {RemoveNodeHandler} from '../../../commands/remove-node-handler';
import {PathwaysModeling} from '../../../commands/pathways-modeling';
import EventBus from 'diagram-js/lib/core/EventBus';
import {FloatingNodesService} from "@ispm/shared/bpmn-io/services/floating-nodes-service";
import {isEmpty} from 'lodash';
import {Store} from "@ngrx/store";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";

export class MarkNodeDeletedHandler extends RemoveNodeHandler {


  constructor(pathwaysModeling: PathwaysModeling, eventBus: EventBus, floatingNodesService: FloatingNodesService,store$: Store<State>,elementRegistry) {
    super(pathwaysModeling, eventBus, floatingNodesService, store$, elementRegistry);
  }

  postExecute(context): any {
    const elementsToRemove = context.elementsToRemove;
    if (!isEmpty(elementsToRemove)) {
      this.updateDirectTreeAfterRemovingNode(context.element);
    }
  }
}
